import Vue from 'vue'
import mixins from './_mixins'

Vue.mixin({
  data: function () {
    return {
      userId: null,
      userRole: null
    }
  },
  methods: mixins,
})